import { CacheableDataObject } from '../models/CacheableDataObject.jsx';
import moment from 'moment';

export default class MatchGameTeam extends CacheableDataObject {
	beforeConstruct() {
		this.match_report = null;
		this.temporaryDecision = undefined;
	}

	updatedPendingDecision(set) {
		if(this.getMatchReportValueToRepresentMyDecision() === set) {
			this.temporaryDecision = null;
		}
		else {
			this.temporaryDecision = set;
		}
	}

	removePendingDecision() {
		this.temporaryDecision = undefined;
	}

	getMatchReportValueToRepresentMyDecision() {
		return this.temporaryDecision === undefined ? this.match_report : this.temporaryDecision;
	}

	reportedWin() {
		return this.getMatchReportValueToRepresentMyDecision() === WIN_MATCH;
	}

	reportedLoss() {
		return this.getMatchReportValueToRepresentMyDecision() === LOSE_MATCH;
	}

	reportedNothing() {
		return this.getMatchReportValueToRepresentMyDecision() === null;
	}
}

MatchGameTeam.prototype.dataLocationParsers = {
	match_report: (matchGameTeam, data) => {
		if(data.match_report) {
			matchGameTeam.match_report = Number.parseInt(data.match_report);
		}
		else {
			matchGameTeam.match_report = null;
		}
	},
	report_time: (matchGameTeam, data) => {
		if(data.report_time) {
			matchGameTeam.report_time = moment.unix(data.report_time);
		}
	},
	number: (matchGameTeam, data) => {
		if(data.number) {
			matchGameTeam.number = Number.parseInt(data.number);
		}
		else {
			matchGameTeam.number = null;
		}
	}
};